module.exports = __webpack_public_path__ + "static/media/b2.461ed8b0.jpg";